import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SearchDocumentModel } from '../../Interfaces'

interface SearchParamsState {
  searchParams: SearchDocumentModel | null
}

const initialState: SearchParamsState = {
  searchParams: null
}

const searchParamsSlice = createSlice({
  name: 'searchParams',
  initialState,
  reducers: {
    setSearchParams: (state, action: PayloadAction<SearchDocumentModel>) => {
      state.searchParams = action.payload
    },
    clearSearchParams: (state) => {
      state.searchParams = null
    }
  }
})

export const { setSearchParams, clearSearchParams } = searchParamsSlice.actions
export const searchParamsReducer = searchParamsSlice.reducer
